import React, { useState, useEffect, useLayoutEffect } from "react";
import Loading from "../../assets/lightloading.png";
import Question from "./Question";
import "./index.scss";
import Result from "../Result";
import { useTransition, animated } from "react-spring";

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

const Questions = ({ questions, restartGame, system }) => {
  const [points, setPoints] = useState(0);
  const [current, setCurrent] = useState(questions.length);
  const [width, height] = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [opacity, setOpacity] = useState(0);
  const transitions = useTransition(loading, null, {
    from: { opacity: 1 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3500);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setOpacity(100);
    }, 2000);
  }, []);

  const handleSubmitAnswer = (singlepoints, index) => {
    document.getElementById(`questions-detect`).style.transition = `all 1s ease-in-out`;
    if (index < questions.length - 1) {
      setPoints(points => points + singlepoints);
      setCurrent(current => current - 1);
    } else if (index === questions.length - 1) {
      setPoints(points => points + singlepoints);
      setCurrent(current => current - 1);
    }
  };

  const handleRestartGame = () => {
    setPoints(0);
    restartGame();
  };

  return (
    <div id="questions-list" className="questions-container" style={{ height: height, overflow: "hidden" }}>
      {transitions.map(
        ({ item, key, props }) =>
          item && (
            <animated.div className="loading" key={key} style={{ ...props, maxWidth: system === "unknown" && `425px` }}>
              <img src={Loading} width="100px" />
              <p>游戏加载中...</p>️
            </animated.div>
          )
      )}

      {questions && (
        <div
          className={`questions`}
          id="questions-detect"
          style={{
            transform: `translateY(-${height * current}px)`,
            opacity: opacity,
            transition: `all 1s linear`,
            willChange: `transform`,
          }}
        >
          {questions.map((item, index) => (
            <Question
              key={item.id}
              item={item}
              submitAnswer={singlepoints => handleSubmitAnswer(singlepoints, index)}
              index={index}
              current={current}
              system={system}
            />
          ))}
          <div id="result">
            <Result points={points} system={system} restartGame={() => handleRestartGame()} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Questions;
